"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCollectorMinRequired = exports.setCollectorCurrentCollected = exports.resetCollectorCurrentCollected = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var initialState = {
    collectorCurrentCollected: 0,
    collectorLastCollected: 0,
    collectorMinRequired: 1,
};
var mazeSlice = (0, toolkit_1.createSlice)({
    name: 'maze',
    initialState: initialState,
    reducers: {
        resetCollectorCurrentCollected: function (state) {
            state.collectorCurrentCollected = 0;
        },
        setCollectorCurrentCollected: function (state, action) {
            state.collectorCurrentCollected = action.payload;
            state.collectorLastCollected = action.payload;
        },
        setCollectorMinRequired: function (state, action) {
            state.collectorMinRequired = action.payload;
        },
    },
});
exports.resetCollectorCurrentCollected = (_a = mazeSlice.actions, _a.resetCollectorCurrentCollected), exports.setCollectorCurrentCollected = _a.setCollectorCurrentCollected, exports.setCollectorMinRequired = _a.setCollectorMinRequired;
exports.default = mazeSlice.reducer;
